import React, { useMemo } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../../ui/tabs';
import { ScrollArea } from '../../../ui/scroll-area';
import { setSidebarTab, useSelectedSidebarTab } from '../../documents/editor/EditorContext.tsx';
import { createEmailEditorTheme } from '../../theme/muiTheme.js';

import ConfigurationPanel from './ConfigurationPanel';
import StylesPanel from './StylesPanel.tsx';
import TemplatePanel from './TemplatePanel';

/**
 * Inspector content without the MUI Drawer wrapper.
 * This component is meant to be rendered inside a ResizablePanel.
 */
export default function InspectorContent() {
  const selectedSidebarTab = useSelectedSidebarTab();

  // Create MUI theme that matches our shadcn/Tailwind colors
  const muiTheme = useMemo(() => createEmailEditorTheme(), []);

  return (
    <div className="flex flex-col h-full bg-sidebar border-l border-sidebar-border">
      <Tabs value={selectedSidebarTab} onValueChange={setSidebarTab} className="flex flex-col h-full">
        {/* Tab Headers */}
        <div className="flex-shrink-0 border-b border-sidebar-border bg-sidebar">
          <TabsList className="w-full justify-start rounded-none h-12 bg-transparent p-0">
            <TabsTrigger
              value="template"
              className="rounded-none data-[state=active]:border-b-2 data-[state=active]:border-primary"
            >
              Template
            </TabsTrigger>
            <TabsTrigger
              value="styles"
              className="rounded-none data-[state=active]:border-b-2 data-[state=active]:border-primary"
            >
              Styles
            </TabsTrigger>
            <TabsTrigger
              value="block-configuration"
              className="rounded-none data-[state=active]:border-b-2 data-[state=active]:border-primary"
            >
              Inspect
            </TabsTrigger>
          </TabsList>
        </div>

        {/* Tab Content - Wrap MUI panels with ThemeProvider */}
        <ThemeProvider theme={muiTheme}>
          <div className="flex-1 min-h-0">
            <TabsContent value="template" className="h-full m-0 p-0">
              <ScrollArea className="h-full">
                <TemplatePanel />
              </ScrollArea>
            </TabsContent>

            <TabsContent value="styles" className="h-full m-0 p-0">
              <ScrollArea className="h-full">
                <StylesPanel />
              </ScrollArea>
            </TabsContent>

            <TabsContent value="block-configuration" className="h-full m-0 p-0">
              <ScrollArea className="h-full">
                <ConfigurationPanel />
              </ScrollArea>
            </TabsContent>
          </div>
        </ThemeProvider>
      </Tabs>
    </div>
  );
}
